// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ArrowDown as RawArrowDown } from "lucide-react";
export const ArrowDown = /* @__PURE__ */ createIcon(RawArrowDown, "ArrowDown", 2);
